import React from "react";

const TheTeam = () => {
	return (
		<div
			className="bg-gradient-to-r py-20 lg:p-20 from-purple-900 to-gray-900 sm:w-full "
			id="team"
		>
			<div
				className="md:max-w-7xl md:mx-auto flex items-center flex-col"
				data-aos="fade-up"
			>
				<h1 className="text-4xl text-white ">The</h1>
				<h1 className="text-center text-6xl font-bold text-purple-600 -mt-2">
					Medusa Team
				</h1>

				<div className="grid grid-cols-1 md:grid-cols-2 gap-7 pt-20 md:max-w-5xl">
					<div className="flex items-center content-center flex-col">
						<img className="h-44 mb-6" src={"./team1.png"} />
						<h1 className="text-xl text-white">Founder</h1>
						<h1 className="text-3xl font-bold  text-white -mt-1">Asuna</h1>
						<p className="text-center text-gray-300 pt-5 text-md mb-6 w-3/4">
							Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt
							cupiditate quisquam qui iure! Esse in expedita eligendi impedit
							totam facere incidunt tempora veniam quaerat neque quos, non nihil
							cupiditate nam?
						</p>
						<a
							href="https://www.fiverr.com/share/EXazN9"
							className="cursor-pointer"
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="48"
								height="48"
								viewBox="0 0 24 24"
								className="hover:fill-white transition-all duration-300 ease-out"
							>
								<path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
							</svg>
						</a>
					</div>
					<div className="flex items-center content-center flex-col">
						<img className="h-44 mb-6" src={"./team1.png"} />
						<h1 className="text-xl text-white">Co-Founder</h1>
						<h1 className="text-3xl font-bold  text-white -mt-1">Rei</h1>
						<p className="text-center text-gray-300 pt-5 text-md mb-6 w-3/4">
							Lorem ipsum dolor, sit amet consectetur adipisicing elit. Officia
							libero nesciunt hic, deleniti maxime modi, pariatur ex magni
							voluptate autem amet eligendi quo dolores ratione cumque quisquam
							ipsa voluptatum minus.
						</p>
						<a
							href="https://www.fiverr.com/share/EXazN9"
							className="cursor-pointer"
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="48"
								height="48"
								viewBox="0 0 24 24"
								className="hover:fill-white transition-all duration-300 ease-out"
							>
								<path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
							</svg>
						</a>
					</div>
				</div>
			</div>
		</div>
	);
};

export default TheTeam;
